import { Locale } from '@/i18n/models/Locale';
import { isNotDefined } from './CheckUtils';

export function isSupportedLang(lang: Locale | string): lang is Locale {
  return lang === Locale.EN || lang === Locale.NL;
}

export function toLocale(str: string | Locale | undefined): Locale | undefined {
  if (isNotDefined(str)) return undefined;
  if (isSupportedLang(str)) return str as Locale;
  if (getShortLocaleName(str) === 'en') return Locale.EN;
  if (getShortLocaleName(str) === 'nl') return Locale.NL;

  return undefined;
}

function getShortLocaleName(lang: Locale | string): string {
  return lang.substring(0, 2);
}
